import React from 'react';
import { useTranslation } from 'react-i18next';

interface ServerLocationSelectorProps {
  selectedLocation: 'falkenstein';
  onLocationChange: (location: 'falkenstein') => void;
}

export function ServerLocationSelector({ selectedLocation }: ServerLocationSelectorProps) {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center space-x-4 mb-8">
      <div className="flex items-center space-x-2 px-4 py-2 rounded-lg bg-blue-600 text-white">
        <img
          src="https://flagcdn.com/w20/de.png"
          width="20"
          height="15"
          alt="Germany"
          className="rounded"
        />
        <span>Falkenstein, Germany</span>
      </div>
    </div>
  );
}